<template>
  <div>
    <move-attachments-modal ref='moveAttachmentsModal' />
    <attached-files-to-msg ref='uploadAttachmentsModal' @complete='attachItemsFromPC'/>
    <attached-files-from-my-relatico ref='uploadAttachmentsMyRelaticoModal' @complete='attachItemsFromMyRelatico'/>

    <modal ref="createTemplate">
      <template #header>
        <h5 class="modal-title mt-0">{{ $t('header.new_template_name') }}</h5>
      </template>
      <template #body>
        <form @submit.prevent='createTemplateForm($event)'>
          <input type='hidden' name='request_template[message]' :value='message'/>

          <div class='modal-body'>
            <div class='form-group'>
              <input required='required' type='text' name='request_template[name]' class='form-control'>
            </div>
          </div>

          <div class='modal-footer'>
            <input @click.prevent='closeTemplateModals()' type='reset' name='commit' :value="$t('header.cancel')"
                   class='btn btn-neutral'>
            <input type='submit' name='commit' :value="$t('header.save')" class='btn btn-primary'>
          </div>
        </form>
      </template>
    </modal>

    <modal ref='deleteTemplate' class="delete-template">
      <template #header>
        <h5 class='modal-title mt-0'>{{ $t('header.delete_saved_template') }}</h5>
      </template>

      <template #body>
        <div class='modal-body'>
          {{ $t('header.this_will_delete', { template: templateToDelete.name }) }}
        </div>

        <div class='modal-footer'>
          <input @click.prevent='closeTemplateModals()' type='reset' :value="$t('header.cancel')"
                 class='btn btn-outline-primary'>
          <input @click.prevent='deleteTemplate()' type='submit' :value="$t('header.delete')" class='btn btn-danger'>
        </div>
      </template>
    </modal>

    <signature ref="signature_component" @modalClose="openSendMessageModal()"/>

    <modal ref='sendMessage' class="send-message">
      <template #header>
        <h5 class="modal-title mt-0">{{ $t('header.send_message') }}</h5>
        <a :href="sendMessageVideo()" target="_blank" class="own-tooltip own-tooltip-bottom video-link" :data-tooltip="$t('header.click_here_to_watch')"><img src="../assets/video.svg" /></a>
      </template>

      <template #body>
        <div v-if="unverifiedUser" class="unverified-info">
          <p>
            {{ $t('verify.info_send_1') }} <strong> {{ $t('verify.info_send_2') }}  </strong> {{ $t('verify.info_send_3') }}
            <br>
            {{ $t('verify.info_part_2') }}
          </p>
        </div>
        <form @submit.prevent="send">
          <div class="modal-body">
            <div class="form-group">
              <label class="folder-label">
                {{ $t('header.contact') }}
              </label>
              <label class="bcc" @click="showBcc = !showBcc">{{ $t('header.add_bcc') }}</label>
              <single-select :template='contactTemplate' :getter='getContacts' name='document_request[receiver_id]' v-model="contact" @input='updateSelectedFolder' class='form-control'/>
            </div>

            <div class="form-group" v-if="showBcc">
              <label>Bcc</label>
              <single-select :template='contactTemplate' :getter='getContacts' name='bcc_id' v-model="selected_bcc" class='form-control'/>
            </div>

            <div class="form-group">
              <label for='send_to_user'>
                <input type='checkbox' name='send_to_user' v-model='currentUserCC' />

                <div v-if="currentUserCC" class="me_as_cc">
                  {{ $t('header.remove_cc') }}
                </div>
                <div v-else class="me_as_cc">
                  {{ $t('header.cc_me_recipent') }}
                </div>
              </label>

              <select v-if="currentUserCC" class="form-control" disabled='disabled'>
                <option>
                  {{ currentUser.email }}
                </option>
              </select>
            </div>

            <div class="form-group">
              <label style="width: 100%">
                {{ $t('header.subject') }}
              </label>
              <input class="form-control" name="document_request[subject]" :placeholder="$t('header.subject_placeholder')">
            </div>

            <div class="form-group attach">
              <button aria-expanded="false" aria-haspopup="true" data-toggle="dropdown" type="button" class="fas fa-paperclip attach-files dropdown-toggle"></button>
              <div class="dropdown-menu dropdown-menu-right">
                <ul>
                  <li @click.prevent='openAttachFilesModal()' class="attach-option">
                    <i class="fas fa-tv"></i>
                    {{ $t('header.upload_computer') }}
                  </li>
                  <li @click.prevent='openAttachFilesMyRelaticoModal()' class="attach-option">
                    <i class="fas fa-folder-open"></i>
                    {{ $t('header.choose_from_relatico') }}
                  </li>
                </ul>
              </div>

              <label>
                {{ $t('header.message') }}
              </label>

              <input id="message" type="hidden" name="document_request[message]">
              <trix-editor input="message" name="document_request[message]" :placeholder="$t('header.write_message')" ref="trix"></trix-editor>
              <ul class="attached-records">
                <li v-for='record in attachedRecords.slice(0, 5)' :key='record.id'>
                  <span @click='removeFromAttachedRecords(record)' class="remove-attached">x</span>
                  <img src="../assets/file_icons/default_icon.svg" alt="File" />
                  {{ record.filename }}
                </li>
              </ul>
              <span v-if="attachedRecords.length > 5" class="float-right files-more">
                  + {{ attachedRecords.length - 5}} {{ $t('header.more_files') }}
              </span>
            </div>
            <div>

            </div>
            <div class="form-group">
              <label for='request_files'>
                <input type='checkbox' name='document_request[request_files]' v-model='requestFiles' @change='updateSelectedFolder' />
                {{ $t('header.request') }}
              </label>

              <input type='hidden' name='document_request[folder_id]' :value='folder.id' v-if='!requestFiles' />

              <div v-if="Object.keys(contact).length > 0">
                <label class="folder-label">{{ $t('header.folder') }}</label>

                <single-select :template='folderTemplate' :getter='getFoldersByContact' name='document_request[folder_id]' :class="{'disabled': !requestFiles}" v-model='folder' @input='getFolderChecklist' />

                <div v-if='checklists.length > 0 && showChecklistItems' class="form-group dr_check_list_items visible">
                  <label>
                    {{ $t('header.checklist') }}
                    <p class="info-reminder own-tooltip own-tooltip-right" :data-tooltip="$t('header.info')">
                      <i class="fas fa-info-circle"></i>
                    </p>
                  </label>
                  <div class="search-container-wrapper">
                    <i class="fas fa-search"></i>
                    <i class="fas fa-times" v-if="checklistSearch.length > 0" @click.prevent="checklistSearch = ''"></i>
                    <input
                      type="text"
                      v-model="checklistSearch"
                      name="search"
                      class="form-control search-field"
                      autocomplete="off"
                      :placeholder="$t('checklist.search')" />
                  </div>

                  <p v-if='canMakeAllVisible' class="select-all-items">
                    <label class="checkbox-container own-tooltip own-tooltip-top" :data-tooltip="$t('header.items_visible')">
                      <input type="checkbox" name="item[shared]" @click.prevent="updateAllItems({shared: true})">
                      <span class="checkmark far fa-eye"></span>
                    </label>
                    {{ $t('header.checklist_visible') }}
                    <span class="icon-info">{{ $t('header.use_icon') }}</span>
                  </p>
                  <p v-else class="select-all-items">
                    <label class="checkbox-container own-tooltip own-tooltip-top" :data-tooltip="$t('header.items_not_visible')">
                      <input type="checkbox" name="item[shared]" @click.prevent="updateAllItems({shared: false})">
                      <span class="checkmark far fa-eye-slash"></span>
                    </label>
                    {{ $t('header.checklist_visible') }}
                    <span class="icon-info">{{ $t('header.use_icon') }}</span>
                  </p>

                  <ul class="clearfix">
                    <li v-for="item in filteredChecklist">
                      <label class="checkbox-container">
                        <input type="checkbox" name="item[shared]" @change.prevent="updateItem(item)" :checked="item.shared">
                        <span class="checkmark far fa-eye-slash"></span>
                      </label>
                      <span class="dt-item">{{ item.document.name }}</span>
                      <span class="product-item">{{ item.product.name }}</span>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
            <div>
            </div>
          </div>

          <div class="modal-footer">
            <p class="message-date">{{ $t('header.message_sent_on')}} {{formatDate(futureSending)}}</p>

            <div class="dropdown">
              <button class="btn btn-neutral" type="button" data-toggle="dropdown" @click='store.getSignatures()'>
                {{ $t('header.signature.signatures') }} <i class="fas fa-sort-down"></i>
              </button>

              <ul class="dropdown-menu">
                <li>
                  <a tabindex="-1" href="#" class="dropdown-item" @click.prevent='openSignatureModal()'>
                    {{ $t('header.signature.create') }}
                  </a>
                </li>

                <li class="dropdown-submenu dropright btn-group" @mouseover='showSignatureMenu = true' @mouseleave='showSignatureMenu = false'>
                  <a tabindex="-1" href="#" :class="['dropdown-item', { disabled: signatures.length == 0}]">
                    {{ $t('header.signature.load') }} <i class="fas fa-caret-right"></i>
                  </a>

                  <ul v-if='showSignatureMenu && signatures.length > 0' class="dropdown-menu submenu">
                    <li v-for='signature in signatures' :key='signature.id'>
                      <a @click.prevent=setSignatureForEditor(signature) tabindex="-1" href="#" class="dropdown-item">
                        {{ signature.name }}
                      </a>
                    </li>
                  </ul>
                </li>

                <li class="dropdown-submenu dropright btn-group" @mouseover='showSignatureDeleteMenu = true' @mouseleave='showSignatureDeleteMenu = false'>
                  <a tabindex="-1" href="#" :class="['dropdown-item', { disabled: signatures.length == 0 }]">
                    {{ $t('header.signature.delete') }} <i class="fas fa-caret-right"></i>
                  </a>

                  <ul v-if='showSignatureDeleteMenu && signatures.length > 0' class="dropdown-menu submenu">
                    <li v-for='signature in signatures' :key='signature.id'>
                      <a @click.prevent='openDeleteSignatureModal(signature)' tabindex="-1" href="#"
                         class="dropdown-item">{{ signature.name }}</a>
                    </li>
                  </ul>
                </li>
              </ul>
            </div>

            <div class="dropdown">
              <button class="btn btn-neutral" type="button" data-toggle="dropdown" @click='store.getTemplates()'>
                {{ $t('header.templates') }} <i class="fas fa-sort-down"></i>
              </button>

              <ul class="dropdown-menu">
                <li>
                  <a tabindex="-1" href="#" class="dropdown-item" @click.prevent='openTemplateModal()'>
                    {{ $t('header.save_template') }}
                  </a>
                </li>

                <li class="dropdown-submenu dropright btn-group" @mouseover='showTemplateMenu = true' @mouseleave='showTemplateMenu = false'>
                  <a tabindex="-1" href="#" :class="['dropdown-item', { disabled: templates.length == 0}]">
                    {{ $t('header.load_template') }} <i class="fas fa-caret-right"></i>
                  </a>

                  <ul v-if='showTemplateMenu && templates.length > 0' class="dropdown-menu submenu">
                    <li v-for='template in templates' :key='template.id'>
                      <a @click.prevent=setTemplateForEditor(template) tabindex="-1" href="#" class="dropdown-item">
                        {{ template.name }}
                      </a>
                    </li>
                  </ul>
                </li>

                <li class="dropdown-submenu dropright btn-group" @mouseover='showTemplateDeleteMenu = true' @mouseleave='showTemplateDeleteMenu = false'>
                  <a tabindex="-1" href="#" :class="['dropdown-item', { disabled: templates.length == 0 }]">
                    {{ $t('header.delete_template') }} <i class="fas fa-caret-right"></i>
                  </a>

                  <ul v-if='showTemplateDeleteMenu && templates.length > 0' class="dropdown-menu submenu">
                    <li v-for='template in templates' :key='template.id'>
                      <a @click.prevent='openDeleteTemplateModal(template)' tabindex="-1" href="#"
                         class="dropdown-item">{{ template.name }}</a>
                    </li>
                  </ul>
                </li>
              </ul>
            </div>
            <input type="submit" name="commit" :disabled='isDisabled' :value="$t('header.send')" class="btn btn-primary float-right send-message-button">
            <button class="btn btn-primary float-right open-timeline-button" type="button" :disabled='isDisabled' @click="showTimeSet = !showTimeSet"><i class="fas fa-caret-right"></i></button>
            <div class="set-sending-time" v-if="showTimeSet">
              <p>{{ $t('header.schedule_sending') }}
                <i class="fas fa-times float-right" @click="showTimeSet = !showTimeSet"></i>
              </p>
              <datepicker
                ref="datepicker"
                name="document_request[sending_date]"
                v-model="futureSending"
                input-class="form-control expiration-input"
                :inline="true"
                :typeable="true"
                :full-month-name="true"
                :disabled-dates = "{to: new Date(Date.now())}"
                :monday-first="true"
                @selected="closeDatePicker"
                :placeholder="$t('expiration.pick_date')">
              </datepicker>
            </div>
            <input type="hidden" name="document_request[sending_date]" :value="formatDate(futureSending)">
          </div>
        </form>
      </template>
    </modal>
  </div>
</template>

<script>
  import _modal from './_modal'
  import _single_select from './shared/_infinite_single_select'
  import Datepicker from 'vuejs-datepicker'
  import _signature from './_signature_modal'
  import 'trix'
  import 'trix/dist/trix.css'

  import _attached_files_to_msg_form from './_attached_files_to_msg_form'
  import _attached_files_from_my_relatico_form from './_attached_files_from_my_relatico_form'
  import _move_attachments_modal from './_move_attachments_modal'

  export default {
    components: {
      'modal': _modal,
      'single-select': _single_select,
      'datepicker': Datepicker,
      'signature': _signature,
      'attached-files-to-msg': _attached_files_to_msg_form,
      'attached-files-from-my-relatico': _attached_files_from_my_relatico_form,
      'move-attachments-modal': _move_attachments_modal,
    },
    created() {
      this.store.getDefaultSignature()
    },
    data() {
      return {
        message: '',
        folder: {},
        rootFolder: {},
        contact: {},
        checklistSearch: '',
        requestFiles: false,
        currentUserCC: false,
        templateToDelete: {},
        showChecklistItems: false,
        showTemplateMenu: false,
        showTemplateDeleteMenu: false,
        futureSending: new Date(),
        showTimeSet: false,
        selected_bcc: {},
        showSignatureMenu: false,
        showSignatureDeleteMenu: false,
        showBcc: false,
        attachedRecordsFromPC: [],
        attachedRecordsFromMyRelatico: [],
      }
    },
    computed: {
      contacts() {
        return this.lists.contacts || []
      },
      folders() {
        return this.lists.folders || []
      },
      templates() {
        return this.state.templates || []
      },
      signatures() {
        return this.state.signatures || []
      },
      checklists() {
        return this.lists.checklists || []
      },
      filteredChecklist() {
        if (!this.checklistSearch)
          return this.checklists

        const lowerQ = this.checklistSearch.toLowerCase()
        return this.checklists.filter(v => v.document.name.toLowerCase().indexOf(lowerQ) >= 0 || v.product.name.toLowerCase().indexOf(lowerQ) >= 0)
      },
      groupByDocumentType() {
        let res = {}

        this.checklists.forEach((item) => {
          const key = item.document_type.name

          if (!res[key])
            res[key] = []

          res[key].push(`${item.product.name} - ${item.product.code}`)
        })

        return res
      },
      canMakeAllVisible() {
        return this.filteredChecklist.some(ci => !ci.shared)
      },
      defaultSignature(){
        return this.state.default_signature
      },
      isDisabled() {
        return this.unverifiedUser || !this.contact.email
      },
      attachedRecords() {
        return this.attachedRecordsFromPC.concat(this.attachedRecordsFromMyRelatico)
      },
    },
    methods: {
      open() {
        this.contact = this.$route.name.indexOf('contact') < 0 ? {} : this.state.contact
        this.requestFiles = false
        this.currentUserCC = false
        this.showChecklistItems = false
        this.selected_bcc = {}
        this.attachedRecordsFromMyRelatico = []
        this.attachedRecordsFromPC = []

        if (this.defaultSignature)
          this.$refs.trix.innerHTML = this.defaultSignature.content

        this.store.getRootFolder().then(() => {
          this.rootFolder = this.state.folder
          this.folder = this.$route.name.indexOf('contact') < 0 ? {} : this.rootFolder
          this.$refs.sendMessage.open()
        })
      },
      getContacts(params) {
        return this.listStore.getContacts(params)
      },
      getFoldersByContact(params) {
        return this.listStore.getFolders(Object.assign({ 'filters[contact_id_eq]': this.contact.id }, params))
      },
      send(e) {
        let formData = new FormData(e.target)
        this.attachedRecords.forEach((r) => {
          formData.append('attachments[record_ids][]', r.id)
        })

        this.store.createDocumentRequest(formData).then((data) => {
          this.store.sendDocumentRequest(data.data.id)
          this.store.sendMetrics({name: 'send_message', params: this.$route.params, path: this.$route.fullPath})
          e.target.reset()
          this.message = null
          this.futureSending = new Date()
          this.$toastr.success(this.$t('request_new_version.success'))
          this.$refs.sendMessage.close()
          this.attachedRecordsFromMyRelatico = []
          this.contact = {}

          if (this.attachedRecordsFromPC.length > 0) {
            this.$refs.moveAttachmentsModal.open(this.attachedRecordsFromPC.slice())
            this.attachedRecordsFromPC = []
          }
        })
      },
      createTemplateForm(e) {
        this.store.createTemplate(new FormData(e.target)).then(() => {
          this.store.sendMetrics({name: 'create_template', params: this.$route.params, path: this.$route.fullPath})
          this.store.getTemplates()
          this.closeTemplateModals()
        })
      },
      openSendEmailInFuture() {
        this.$refs.sendEmailDate.open()
      },
      openTemplateModal() {
        this.message = this.$refs.trix.innerHTML //HOTFIX. kill me
        this.$refs.sendMessage.close()
        this.$refs.createTemplate.open()
      },
      setTemplateForEditor(template) {
        let msg = template.message

        if (this.defaultSignature)
          msg = msg + this.defaultSignature.content

        this.$refs.trix.innerHTML = msg // HOTFIX kill.me
        this.message = msg
      },
      openDeleteTemplateModal(template) {
        this.templateToDelete = Object.assign({}, template)
        this.$refs.sendMessage.close()
        this.$refs.deleteTemplate.open()
      },
      closeTemplateModals() {
        this.$refs.createTemplate.close()
        this.$refs.deleteTemplate.close()
        this.$refs.sendMessage.open()
      },
      deleteTemplate() {
        this.store.destroyTemplate(this.templateToDelete.id).then(() => {
          this.store.sendMetrics({name: 'remove_template', params: this.$route.params, path: this.$route.fullPath})
          this.store.getTemplates()
          this.closeTemplateModals()
        })
      },
      setSignatureForEditor(signature) {
        let msg = this.$refs.trix.innerHTML + signature.content
        this.$refs.trix.innerHTML = msg
        this.message = msg
      },
      updateSelectedFolder() {
        this.message = this.$refs.trix.value
        this.folder = this.contact.id && this.requestFiles ? {} : this.rootFolder
      },
      getFolderChecklist() {
        if (!this.folder.id)
          return

        this.listStore.getChecklistItems({ 'filters[checked]': false, 'filters[folder_id]': this.folder.id }).then(() => {
          this.showChecklistItems = true
        })
      },
      updateAllItems(params) {
        const items = this.filteredChecklist.map(ci => ci.id)

        if (items.length == 0)
          return

        this.store.executeBulkOperation('hide', items, params).then(() => {
          this.getFolderChecklist()
        })
      },
      updateItem(item) {
        let params = {
          item: { shared: !item.shared }
        }

        this.store.updateChecklistItem(item.id, params).then(() => {
          this.getFolderChecklist()
        })
      },
      closeDatePicker() {
        this.$refs.datepicker.close()
        this.showTimeSet = false
      },
      openSignatureModal(){
        this.$refs.sendMessage.close()
        this.$refs.signature_component.open()
      },
      openDeleteSignatureModal(signature){
          this.$refs.sendMessage.close()
          this.$refs.signature_component.openDelete(signature)
      },
      openSendMessageModal(){
        this.$refs.sendMessage.open()
      },
      openAttachFilesModal(){
        this.$refs.sendMessage.close()
        Object.keys(this.folder).length == 0 ?  this.$refs.uploadAttachmentsModal.open(this.folders.find(f => f.primary)) : this.$refs.uploadAttachmentsModal.open(this.folder)
      },
      openAttachFilesMyRelaticoModal(){
        this.$refs.sendMessage.close()
        this.$refs.uploadAttachmentsMyRelaticoModal.open()
      },
      attachItemsFromMyRelatico(attachedFiles) {
        this.attachedRecordsFromMyRelatico.push(...attachedFiles)

        this.$refs.sendMessage.open()
      },
      attachItemsFromPC(attachedFiles) {
        this.attachedRecordsFromPC.push(...attachedFiles)

        this.$refs.sendMessage.open()
      },
      removeFromAttachedRecords(record){
        let index = this.attachedRecordsFromPC.indexOf(record)
        if (index >= 0) {
          this.attachedRecordsFromPC.splice(index, 1)
          return
        }

        index = this.attachedRecordsFromMyRelatico.indexOf(record)
        if (index >= 0)
          this.attachedRecordsFromMyRelatico.splice(index, 1)
      },
      sendMessageVideo(){
        if(this.locale === 'de')
          return 'https://relatico.wistia.com/medias/cvffo576qj'
        return 'https://relatico.wistia.com/medias/8dpu3sna2k'
      }
    }
  }
</script>
<style lang="sass" scoped>
  .send-message-button
    margin-right: 0
    border-top-right-radius: 0
    border-bottom-right-radius: 0
  .open-timeline-button
    margin-left: 0
    border-top-left-radius: 0
    border-bottom-left-radius: 0
  .set-sending-time
    position: absolute
    background: #fff
    right: -250px
    padding: 15px
    bottom: 0
    width: 250px
    p
      margin-bottom: 10px
    .fa-times
      font-size: 18px
      cursor: pointer
  .dropdown-menu.submenu
    display: block
    max-height: 200px
    overflow: auto
  .me_as_cc
    display: inline-block
    padding-left: 5px
  .bcc
    float: right
    margin-right: 10px
    cursor: pointer
    &:hover
      text-decoration: underline
  .dr_check_list_items
    padding-top: 30px
    color: #000
    label
      letter-spacing: 1.4px
      font-weight: 300
      color: #686868
      display: block
      float: left
      padding-top: 9px
      margin: 0
      p
        display: inline
    .checkbox-container
      line-height: 21px
      margin-right: 10px
    .icon-info
      font-size: 12px
      display: block
      color: #000
      line-height: 11px
      margin-left: 45px
    .select-all-items
      display: initial
      padding: 15px 0
      line-height: 24px
      margin: 0
      float: left
      .checkmark
        background: transparent
        font-size: 20px
        width: auto
        height: auto
        border: 1px solid #C4C4C4
        border-radius: 3px
        padding: 3px
        &:hover
          background: transparent
      .checkbox-container input:checked ~ .checkmark
        background: transparent
        &:after
          display: none
        &:before
          content: "\f06e"
    ul
      margin: 0
      padding: 0
      list-style: none
      max-height: 300px
      overflow: scroll
      width: 100%
      li
        font-weight: 400
        color: #686868
        line-height: 23px
        font-size: 14px
        display: flex
        flex-wrap: wrap
        align-items: center
        padding: 5px 0
        &:nth-child(2)
          background-color: hsla(0,0%,97.3%,.5)
        .dt-item
          width: 45%
        .product-item
          background: rgba(102, 127, 255, 0.08)
          display: inline-block
          padding: 5px 10px
          border: 1px solid #C4C4C4
          box-sizing: border-box
          border-radius: 3px
        .checkmark
          background: transparent
          font-size: 20px
          width: auto
          height: auto
          &:hover
            background: transparent
        .checkbox-container
          margin-bottom: 0
          height: 19px
          line-height: 19px
          input:checked ~ .checkmark
            background: transparent
            &:after
              display: none
            &:before
              content: "\f06E"
  .search-container-wrapper
    width: 50%
    position: relative
    float: right
    .fa-search
      top: 7px
      left: 10px
    input
      height: 37px
    i
      position: absolute
      opacity: 0.4
      &.fa-search
        left: 9px
        top: 11px
        font-size: 16px
      &.fa-times
        right: 13px
        top: 11px
        font-size: 16px
        cursor: pointer
    input
      padding-left: 40px
      border-color: #e8e8e8
      &::placeholder
        font-size: 14px
        color: #a4a4a4
  .message-date
    margin-right: auto
    margin-bottom: 0
  .attach-files
    border: 1px solid #ccc
    padding: 3px 9px
    background-color: #fff
    border-radius: 3px
    color: #686868
    position: absolute
    top: 30px
    right: 290px
    box-shadow: 0 1px #888
  .form-group.attach
    position: relative
  .attached-records
    margin: 10px 0
    padding: 0
    list-style: none
    display: flex
    flex-wrap: wrap
    li
      text-align: center
      width: 20%
      display: flex
      flex-direction: column
      align-items: center
      img
        width: 40px
  .files-more
    font-weight: 500
  .remove-attached
    margin-left: auto
    font-size: 18px
    font-weight: bold
    padding-right: 10px
    cursor: pointer
  .video-link
    margin: 4px 10px
  .attach-option
    padding: 5px 10px
    cursor: pointer
    &:hover
      background: #f2f2f2
</style>
<style lang="sass">
  trix-editor
    max-height: 150px
    overflow: scroll
  trix-toolbar  .trix-button-group--file-tools
    display: none
  .set-sending-time
    .vdp-datepicker__calendar
      width: 217px
      font-size: 12px
      .cell
        height: 30px
        line-height: 30px
</style>
